/**
 * Hook to access favorites context
 */

import { useContext } from "react";
import { FavoritesContext } from "./favorites-context";

export const useFavorites = () => {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error("useFavorites must be used within FavoritesProvider");
  }
  return context;
};
